"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownWrapper = exports.StyledArrowDown = exports.DropdownBody = exports.SelectedOptionText = exports.HeaderPlaceholder = exports.Label = exports.DropdownHeader = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const icon_1 = __importDefault(require("../../icon"));
const { ArrowDown } = icon_1.default;
exports.DropdownHeader = styled_components_1.default.div `
  display: flex;
  height: 52px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border: solid 2px ${({ theme }) => theme.neutral.main};
  border-radius: 8px;

  border-color: ${({ isError, isDisabled, isOpen, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isOpen
                ? theme.primary.main
                : theme.neutral.main;
    return color;
}};

  background-color: ${({ theme }) => theme.white};
  padding: 7px 12px;
  cursor: pointer;
  min-width: 142px;
`;
exports.Label = styled_components_1.default.label `
  position: absolute;
  pointer-events: none;
  z-index: 2;
  top: 14px;
  left: 20px;
  background-color: ${({ theme }) => theme.white};
  padding: 2px 4px;
  font-size: 16px;
  font-weight: 700;
  transition: top 0.1s ease-in-out, left 0.1s ease-in-out;
  color: ${({ isError, isDisabled, isOpen, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isOpen
                ? theme.primary.main
                : theme.neutral.main;
    return color;
}};
  ${({ hasValue, isOpen }) => (hasValue || isOpen) &&
    (0, styled_components_1.css) `
      top: -10px;
      left: 12px;
      font-size: 14px;
      font-weight: 400;
    `};
`;
exports.HeaderPlaceholder = styled_components_1.default.div `
  font-size: 14px;
  color: ${({ theme }) => theme.neutral.main};
  margin-right: 10px;
  display: ${({ hasValue, isOpen }) => isOpen && !hasValue ? "block" : "none"};
`;
exports.SelectedOptionText = styled_components_1.default.div `
  font-size: 14px;
  color: ${({ theme }) => theme.text.primary};
  margin-right: 10px;
  opacity: ${({ hasValue }) => (hasValue ? 1 : 0)};
`;
exports.DropdownBody = styled_components_1.default.div `
  position: absolute;
  top: ${({ headerHeigh }) => `${headerHeigh + 4}px`};
  left: 0;
  width: 100%;
  z-index: 10;
  box-shadow: 0px 25px 50px 0 #0002;
  border-radius: 4px;
`;
exports.StyledArrowDown = (0, styled_components_1.default)(ArrowDown) `
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: all 0.2s linear;
`;
exports.DropdownWrapper = styled_components_1.default.div `
  position: relative;
  width: 100%;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "all")};

  &:hover {
    ${exports.Label} {
      color: ${({ isError, isDisabled, isOpen, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isOpen
                ? theme.primary.main
                : theme.neutral.dark;
    return color;
}};
    }
    ${exports.DropdownHeader} {
      border-color: ${({ isError, isDisabled, isOpen, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isOpen
                ? theme.primary.main
                : theme.neutral.dark;
    return color;
}};
    }
  }
`;
